module.exports = __webpack_public_path__ + "img/20240911075835014mnl.f8cf6498.jpg";